import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import HeroSection from './HeroSection';
import trainerImg from '../../assets/good_good_img.png'; // Asigură-te că calea e corectă
import './Home.css';

const Home = () => {

    useEffect(() => {
        const sections = document.querySelectorAll('.teaser-section');
        const observer = new IntersectionObserver(
            entries => {
                entries.forEach(entry => {
                    if(entry.isIntersecting){
                        entry.target.classList.add('visible');
                    }
                })
            },
            { threshold: 0.2 }
        );
        sections.forEach(section => observer.observe(section));
    }, []);

    return (
        <>
            <HeroSection />

            {/* --- About Section --- */}
            <section className="teaser-section about-section-neon">
                <div className="about-container">

                    <div className="about-content">
                        <span className="neon-badge">ANTRENORUL TĂU</span>
                        <h2 className="section-title">Salut, sunt <span className="text-highlight">Cosmin Hadade</span></h2>

                        <h3 className="about-subtitle">Creatorul FitSimplu & Specialist în Transformări</h3>

                        <div className="about-bio">
                            <p>
                                Misiunea mea este să te ajut să-ți construiești stilul de viață
                                de la zero, cu o abordare simplă, bazată pe știință și disciplină.
                                Această metodă a fost testată pe mine de-a lungul a 16 ani de sală și
                                numeroase pregătiri pentru concursuri de culturism și fitness.

                                Am ajutat sute de oameni să treacă de la ‘nu pot’ la ‘nu mă pot opri’.
                            </p>
                            <p>
                                Crezi că ești pregătit să renunți la scuze? Hai să lucrăm împreună.
                            </p>
                        </div>

                        <div className="about-stats-row">
                            <div className="stat-box">
                                <span className="stat-number">16+</span>
                                <span className="stat-label">Ani Experiență</span>
                            </div>

                            <div className="stat-box">
                                <span className="stat-number">100%</span>
                                <span className="stat-label">Rezultate reale</span>
                            </div>
                        </div>

                        <Link to="/about" className="btn-neon">Vezi Povestea Mea</Link>
                    </div>

                    <div className="about-image-wrapper">
                        <div className="neon-circle-bg"></div>
                        <img src={trainerImg} alt="Trainer Portrait" className="main-image"/>

                        {/* Floating Card 1 */}
                        <div className="floating-card glass-card heart-pos">
                            <div className="icon-box neon-bg">
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="black"><path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/></svg>
                            </div>
                            <div className="stats-text">
                                <strong>Pasiune</strong>
                                <span>Dedicație totală</span>
                            </div>
                        </div>

                        {/* Floating Card 2 */}
                        <div className="floating-card glass-card burn-pos">
                            <div className="icon-box neon-bg">
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="black"><path d="M9 11.75c-.69 0-1.25.56-1.25 1.25s.56 1.25 1.25 1.25 1.25-.56 1.25-1.25-.56-1.25-1.25-1.25zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8 0-.29.02-.58.05-.86 2.36-1.05 4.23-2.98 5.21-5.37C11.07 8.33 14.05 10 17.42 10c.78 0 1.53-.09 2.25-.26.21 1.01.33 2.05.33 3.14 0 4.41-3.59 8-8 8z"/></svg>
                            </div>
                            <div className="stats-text">
                                <strong>Focus</strong>
                                <span>Mentalitate</span>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* --- Plans Section (UPDATED) --- */}
            <section className="teaser-section plans-section-neon">
                <div className="plans-header">
                    <h2>Investește în tine</h2>
                    <p className="subtitle">Alege nivelul de disciplină potrivit pentru obiectivele tale.</p>
                </div>

                <div className="pricing-grid">

                    {/* PLAN 1: STARTER */}
                    <div className="pricing-card dark-card">
                        <h4>🟢 Fit Simplu Starter</h4>
                        <p style={{fontSize:'0.85rem', color:'#888', marginBottom:'15px'}}>Primul pas către disciplină.</p>

                        <div className="price">
                            700 Lei <span className="period">/ Lună</span>
                        </div>

                        <ul className="features-list">
                            <li><span className="tick">✓</span> Strategie alimentară clară</li>
                            <li><span className="tick">✓</span> Program antrenament profesional</li>
                            <li><span className="tick">✓</span> Acces platformă online</li>
                            <li><span className="tick" style={{color:'#666'}}>•</span> Fără monitorizare constantă</li>
                        </ul>

                        <div style={{marginTop: 'auto'}}>
                            <Link to="/plans" className="btn-outline-neon">Alege Starter</Link>
                        </div>
                    </div>

                    {/* PLAN 2: PRO (RECOMANDAT) */}
                    <div className="pricing-card neon-card">
                        <div className="best-value-badge">RECOMANDAT ⭐</div>
                        <h4>🔵 Fit Simplu Pro</h4>
                        <p style={{fontSize:'0.85rem', color:'#ccc', marginBottom:'15px'}}>Suport complet pentru progres.</p>

                        <div className="price">
                            900 Lei <span className="period">/ Lună</span>
                        </div>

                        <ul className="features-list">
                            <li><span className="tick">✓</span> <strong>Alimentație 100% personalizată</strong></li>
                            <li><span className="tick">✓</span> <strong>Antrenament personalizat</strong></li>
                            <li><span className="tick">✓</span> Ajustări regulate & Feedback</li>
                            <li><span className="tick">✓</span> Monitorizare evoluție</li>
                        </ul>

                        <div style={{marginTop: 'auto'}}>
                            <Link to="/plans" className="btn-black">Vreau Pro</Link>
                        </div>
                    </div>

                    {/* PLAN 3: TRANSFORMARE (ROȘU) */}
                    {/* Am adăugat o clasă extra 'transformation-card-home' pentru stilul roșu */}
                    <div className="pricing-card transformation-card-home">
                        <h4>🔴 Transformation</h4>
                        <p style={{fontSize:'0.85rem', color:'#ff9999', marginBottom:'15px'}}>Transformare completă 12 Săpt.</p>

                        <div className="price" style={{color: '#ff4444'}}>
                            Aplicare <span className="period" style={{color:'#999'}}>/ Doar Interviu</span>
                        </div>

                        <ul className="features-list">
                            <li><span className="tick" style={{color: '#ff4444'}}>🔥</span> Strategie pe 12 săptămâni</li>
                            <li><span className="tick" style={{color: '#ff4444'}}>🔥</span> Alimentație structurată pe etape</li>
                            <li><span className="tick" style={{color: '#ff4444'}}>🔥</span> Antrenament progresiv</li>
                            <li><span className="tick" style={{color: '#ff4444'}}>🔥</span> <strong>Suport Prioritar</strong></li>
                        </ul>

                        <div style={{marginTop: 'auto'}}>
                            <Link to="/plans" className="btn-outline-red">Aplică Acum</Link>
                        </div>
                    </div>

                </div>
            </section>
        </>
    );
};

export default Home;